import { render } from "./downloadBtn.vue?vue&type=template&id=10bc80a0&scoped=true&ts=true"
import script from "./downloadBtn.vue?vue&type=script&lang=ts"
export * from "./downloadBtn.vue?vue&type=script&lang=ts"

import "./downloadBtn.vue?vue&type=style&index=0&id=10bc80a0&scoped=true&lang=less"

import exportComponent from "/data/codingci/tools/jenkins_home/workspace/3099411-cci-43254499-708002/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bc80a0"]])

export default __exports__